<template>
  <span>
    <v-row class="mx-auto mt-5">
      <v-col col lg="6">
        <!--        Individual details-->
        <span v-if="individual_details">
          <h5 class="text-center mt-2">Individual Details</h5>

          <v-list>
            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Name:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >Mutebi Allan</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Phone:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >0703229493</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Nationality:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >Ugandan</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Email:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >mutebiallan@gmail.com</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  NIN/Passport No/Driving Permit/NSSF No:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >CMF34567MNH4567</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </span>

        <!--        company details-->
        <span v-if="company_details">
          <h5 class="text-center mt-2">Company Details</h5>

          <v-list>
            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Company Name:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >Andy and Sons</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  BRN or Reservation Number:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >BR567876</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Registration/ Reservation Date:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >2/20/2020</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Phone Number:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >0703228763</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Email:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >andyandsons@gmail.com</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content
                style="border-bottom: 1px solid #e0e0e0"
                class="text-center"
              >
                <v-list-item-title>
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3"
                    >Contact Person (Director, Shareholders)
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Name:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >musiitwa henry</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Phone:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >0703998765</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Email:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >musiitwa@gmail.com</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </span>

        <!--   	MDA (Ministry, Department, Agency)-->
        <span v-if="mda_details">
          <h5 class="text-center mt-2">MDA (Ministry, Department, Agency)</h5>

          <v-list>
            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  MDA Name:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >Information Technology</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Telephone Number:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >0704987652</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Email:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >info@information.com</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content
                style="border-bottom: 1px solid #e0e0e0"
                class="text-center"
              >
                <v-list-item-title>
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3"
                    >Accounting officer Details</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Name:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >Muwanguzi Ronald</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Email:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >muwanguzi@information.com</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
                <v-list-item-title>
                  Telephone:
                  <span
                    style="color: #666666; font-size: 14px"
                    class="ml-5 mr-3 float-right"
                    >0708730986</span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </span>
      </v-col>

      <v-col col lg="6" style="border-left: 1px solid #e0e0e0">
        <h5 class="text-center mt-2">Box Details</h5>

        <v-list>
          <v-list-item>
            <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
              <v-list-item-title>
                Post Office Station:
                <span
                  style="color: #666666; font-size: 14px"
                  class="ml-5 mr-3 float-right"
                  >Kampala</span
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
              <v-list-item-title>
                Box Number:
                <span
                  style="color: #666666; font-size: 14px"
                  class="ml-5 mr-3 float-right"
                  >Kampala</span
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
              <v-list-item-title>
                Payment Period:
                <span
                  style="color: #666666; font-size: 14px"
                  class="ml-5 mr-3 float-right"
                  >2 Years</span
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
              <v-list-item-title>
                Payment Mode:
                <span
                  style="color: #666666; font-size: 14px"
                  class="ml-5 mr-3 float-right"
                  >Mobile Money</span
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="mt-8">
            <v-list-item-content style="border-bottom: 1px solid #e0e0e0">
              <v-list-item-title style="font-weight: bold; font-size: 25px">
                Amount:
                <span
                  style="color: #666666; font-size: 20px"
                  class="ml-5 mr-3 float-right"
                  >350,000 UGX</span
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <b-form @submit="makePhysicalBoxPayment">
          <div
            class="form-group mt-10 mb-3 mx-auto input-group input-text-wrapper"
          >
            <div class="input-group-prepend">
              <span
                class="input-group-text"
                style="background-color: #ffffff; border: none"
              >
                <font-awesome-icon icon="phone" style="color: #ced4da" />
              </span>
            </div>
            <b-form-input
              class="box-text-input"
              v-model="form.mobile_money_phone"
              type="text"
              required
              placeholder="Mobile Money Phone Number"
            ></b-form-input>
          </div>

          <button
            class="form-control boxSummaryButton button mt-10 mx-auto"
            style="margin-bottom: 4%"
            type="submit"
          >
            Pay
            <b-spinner
              v-if="boxSummarySpinner"
              label="Loading..."
              small
            ></b-spinner>
          </button>
        </b-form>
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  name: "BoxSummary",
  props: ["customerDetails", "boxDetails"],
  data() {
    return {
      individual_details: true,
      company_details: false,
      mda_details: false,
      boxSummarySpinner: false,
      form: {
        mobile_money_phone: null,
      },
    };
  },
  methods: {
    makePhysicalBoxPayment(evt) {
      evt.preventDefault();
      let applyBoxDetails = Object.assign(
        this.form,
        this.customerDetails,
        this.boxDetails
      );

      //alert(JSON.stringify(applyBoxDetails));
      this.$emit("boxSummaryData", applyBoxDetails);
      this.$emit("goTo", 4);
    },
  },
};
</script>

<style scoped>
.input-text-wrapper {
  width: 95%;
  border: #ced4da 1px solid;
  padding: 3px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.box-text-input {
  border: none;
  font-size: 17px;
  height: 40px;
  color: #8898aa;
  outline: none;
  box-shadow: none !important;
}

.boxSummaryButton {
  width: 96%;
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 18px;
  margin-top: 4%;
}
</style>
